import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";

// auth
import { withAuthFlow } from "@trp/authentication-components";

// config
import { getConfig, getConfigPath } from "./utils/config";
import { isInternalDomain, showApp } from "./utils/lib";

// styles
import "./bootstrap.scss";
import "./styles/index.css";

import App from "./components/App";
import Error from "./components/Error";
import ErrorBoundary from "./components/ErrorBoundary";
import ComingSoon from "./components/ComingSoon";

import * as serviceWorker from "./serviceWorker";

const rootElement = document.getElementById("root");

// create authed version of App
const ConfiguredAndAuthenticatedApp = withAuthFlow(App, getConfigPath());

// set isInternalUser
const isInternalUser = isInternalDomain();

const renderApp = (config) => {
	ReactDOM.render(
		<ErrorBoundary>
			<App applicationConfig={config} isInternalUser={isInternalUser} />
		</ErrorBoundary>,
		rootElement
	);
};

const renderAuthApp = () => {
	ReactDOM.render(
		<ErrorBoundary>
			<ConfiguredAndAuthenticatedApp isInternalUser={isInternalUser} />
		</ErrorBoundary>,
		rootElement
	);
};

const renderError = () => {
	ReactDOM.render(<Error />, rootElement);
};

const renderComingSoon = () => {
	ReactDOM.render(<ComingSoon />, rootElement);
};

// get the config and render the App
const getConfigAndRender = async () => {
	if (isInternalUser) {
		renderAuthApp();
	} else {
		const config = await getConfig();

		if (config) {
			const startDate =
				config.environment && config.environment !== "prod"
					? "2019-01-01T00:00:00"
					: "2020-01-01T00:00:00";

			if (showApp(startDate)) {
				renderApp(config);
			} else {
				renderComingSoon();
			}
		} else {
			renderError();
		}
	}
};

getConfigAndRender();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
